import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import styled from 'styled-components'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {Label} from 'lib/ui/typography'
import SolidColorPicker from 'lib/ui/form/BackgroundPicker/SolidColorPicker'
import {WidgetCalendar} from 'organization/Event/WidgetConfig/ButtonStylesConfig/WidgetCalendar'

const DEFAULT_VALUE = 'text'
const DEFAULT_COLOR_SCHEME = 'default'

export default function CalendarTypeColorSelection(props: {
  control: UseFormMethods['control']
  button: WidgetCalendar
  storageKey: string
}) {
  const {button, control} = props

  const colorScheme = control.watchInternal(
    'colorScheme',
    button.colorScheme || DEFAULT_COLOR_SCHEME,
  )

  return (
    <CollapsibleSection label="Type and Colors" storageKey={props.storageKey}>
      <StyledLabel>Buttons Type</StyledLabel>
      <Controller
        name="type"
        defaultValue={button.type || DEFAULT_VALUE}
        control={control}
        render={({value, onChange}) => (
          <Select aria-label="type" onChange={onChange} value={value} fullWidth>
            <Option value={'text'} key={'text'}>
              {'Text'}
            </Option>
            <Option value={'icon'} key={'icon'}>
              {'Icon'}
            </Option>
          </Select>
        )}
      />
      <StyledLabel>Buttons color</StyledLabel>
      <Controller
        name="colorScheme"
        defaultValue={button.colorScheme || DEFAULT_COLOR_SCHEME}
        control={control}
        render={({value, onChange}) => (
          <Select
            aria-label="colorScheme"
            onChange={onChange}
            value={value}
            fullWidth
          >
            <Option value={'default'} key={'default'}>
              {'Default'}
            </Option>
            <Option value={'custom'} key={'custom'}>
              {'Custom'}
            </Option>
          </Select>
        )}
      />

      {colorScheme === 'custom' ? (
        <Controller
          name="color"
          control={control}
          defaultValue={button.color}
          render={({value, onChange}) => (
            <SolidColorPicker
              label="Custom Color"
              background={value}
              onChange={onChange}
            />
          )}
        />
      ) : (
        <></>
      )}
    </CollapsibleSection>
  )
}

const StyledLabel = styled(Label)`
  margin-bottom: ${(props) => props.theme.spacing[4]};
`
